import React from 'react';
import { ShieldCheckIcon, ChevronRightIcon } from 'lucide-react';

const REVENUE_LABELS = {
  under_500k: 'Under $500K',
  '500k_to_1m': '$500K – $1M',
  '1m_to_5m': '$1M – $5M',
  '5m_plus': '$5M+',
};

const INDUSTRY_LABELS = {
  trades_construction: 'Trades & Construction',
  manufacturing: 'Manufacturing',
  professional_services: 'Professional Services',
  retail: 'Retail',
  technology: 'Technology',
  hvac: 'HVAC',
  restaurant: 'Restaurant',
  trades: 'Trades',
  health: 'Health',
  auto: 'Auto',
  saas: 'SaaS',
  other: 'Other',
};

const STATE_BADGE_STYLES = {
  new_deal: 'bg-muted text-muted-foreground',
  published: 'bg-[hsl(var(--succeedo-orange))]/10 text-[hsl(var(--succeedo-orange))] border border-[hsl(var(--succeedo-orange))]/20',
  archived: 'bg-foreground/5 text-muted-foreground border border-border',
};

const STATE_LABELS = {
  new_deal: 'Draft',
  published: 'Live',
  archived: 'Archived',
};

export default function DealListingOwnerRow({ listing }) {
  const stateKey = listing.deal_state || 'new_deal';
  const headline = listing.headline || 'Untitled listing';

  return (
    <a
      href={`/succeedo/deal-room/${listing.id}`}
      className="flex items-center gap-4 px-4 py-3 bg-card border border-border rounded-[12px] hover:border-foreground/20 transition-colors group"
    >
      <span
        className={`shrink-0 font-mono text-[10px] uppercase tracking-wide rounded-full px-2.5 py-1 ${STATE_BADGE_STYLES[stateKey] || STATE_BADGE_STYLES.new_deal}`}
      >
        {STATE_LABELS[stateKey] || stateKey}
      </span>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-[14px] font-medium text-foreground truncate">{headline}</h3>
          {listing.confidential && (
            <ShieldCheckIcon className="w-3.5 h-3.5 text-foreground/40 flex-shrink-0" aria-label="Confidential" />
          )}
        </div>
        <div className="text-[12px] text-muted-foreground truncate">
          {[INDUSTRY_LABELS[listing.industry] || listing.industry, REVENUE_LABELS[listing.revenue_range_bucket]]
            .filter(Boolean)
            .join(' · ')}
        </div>
      </div>

      <ChevronRightIcon className="w-4 h-4 text-muted-foreground/40 group-hover:text-foreground transition-colors shrink-0" />
    </a>
  );
}
